<template>
  <div class="child_tag">
     <div class="child_tag_list">
        <div class="child_tag_list_default">
           <div class="child_tag_list_default_box"
           :class="tagShowList[index] ? 'is_active' : ''"
            v-for="(item,index) in defaultTagList" :key="item.id"
            @click="choiceTag(index)">
              <span>{{item.label}}</span>
           </div>
        </div>
        <div class="child_tag_list_custom">
           <div class="child_tag_list_custom_box" :class="customTagShowList[index] ? 'is_active' : ''" v-for="(val,index) in customTagList" :key="val.id">
              <span class="child_tag_list_custom_box_name" @click="choiceCustomTag(index)">{{val.label}}</span>
              <i class="icon_del" @click="onDelTag(index,val)"></i>
           </div>
           <i class="icon_add_tag" @click="onAddTag"></i>
        </div>
         <div class="child_tag_list_bottom">
            <i class="icon_save" @click="onSave">保存</i>
         </div>
     </div>
     <!-- 新增自定义标签弹窗 -->
     <add-info :infoShow="infoShow" :title="title" @close="onClose" @confirm="onConfirm" :type="type"></add-info>
     <!--删除自定义标签提示框  -->
     <modal
         btnType='2'
         ref="delModal"
         @submit="onSure"
         @cancel='onCancel'>
         <template v-slot:body>
               <p>是否确定删除此自定义标签?</p>
         </template>
      </modal>
  </div>
</template>

<script>
import addInfo from '../../components/children-file/add-info.vue';
import { _saveFavoriteLabel,_getPage,_delFavoriteLabel,_saveSingleFavoriteLabel } from '../../api/children-file';
import { _upload } from "../../api/family-archives";
import Modal from '../common/modal.vue';
export default {
   name:"tag",
   props:{
      componentData:{
         type:Object,
      },
   },
   components:{
      addInfo,
      Modal
   },
   data() {
      return {
         infoShow:false,
         title:'请自定义添加',
         defaultTagList:[], // 默认标签列表
         customTagList:[], // 自定义表现列表
         choiceList:[], // 选中的默认标签
         tagShowList:[], // 默认标签选中的状态
         customTagShowList:[], // 自定义标签选中的状态
         choiceCustomList:[], // 选中的自定义标签
         type:'2',
         delTagIndex:null, // 删除标签的index
         tagId:"",// 自定义标签id
      }
   },
   watch:{
      componentData:{
         handler(data) {
            this.defaultTagList = JSON.parse(JSON.stringify(data.labelList)); // 默认标签
            this.choiceList = JSON.parse(JSON.stringify(data.choiceLabelList)); // 选中的默认标签
            this.tagShowList = JSON.parse(JSON.stringify(data.labelShow)); // 默认标签选中的状态
            this.customTagList = JSON.parse(JSON.stringify(data.customLabelList)); // 自定义标签
            this.choiceCustomList = JSON.parse(JSON.stringify(data.choiceCustomLabelList)); // 选中的自定义标签
            this.customTagShowList = JSON.parse(JSON.stringify(data.customLabelShow)); // 自定义标签选中的状态

            this.defaultTagList.map((item,index)=>{
               this.choiceList.map(val => {
                  if(item.label == val.label){
                     this.$set(this.tagShowList,index,true)
                  }
               })
            })
            this.customTagList.map((item,index)=>{
               this.choiceCustomList.map(val => {
                  if(item.label == val.label){
                     this.$set(this.customTagShowList,index,true)
                  }
               })
            })

         },
         immediate:true,
         deep:true
      },
   },
   created() {

   },
   mounted() {

   },
   methods:{
      // 勾选默认标签
      choiceTag(index) {
         if(this.tagShowList[index]){
            this.$set(this.tagShowList,index,false);
            let delIndex = null;
            this.choiceList.map((item,ject) => {
               if(item.label == this.defaultTagList[index].label){
                  delIndex = ject
               }
            })
            this.choiceList.splice(delIndex,1);
         }else{
            this.$set(this.tagShowList,index,true);
            this.choiceList.push(this.defaultTagList[index]);
         }
      },
      // 勾选自定义标签
      choiceCustomTag(index) {
         if(this.customTagShowList[index]){
            this.$set(this.customTagShowList,index,false);
            let delIndex = null;
            this.choiceCustomList.map((item,ject) => {
               if(item.label == this.customTagList[index].label){
                  delIndex = ject
               }
            })
            this.choiceCustomList.splice(delIndex,1);
         }else{
            this.$set(this.customTagShowList,index,true);
            this.choiceCustomList.push(this.customTagList[index]);
         }
      },
      // 打开新增标签弹窗
      onAddTag() {
         this.infoShow = true;
      },
      // 删除标签
      saveDelLables(index,id) {
         _delFavoriteLabel(id).then(res=>{
            if(res.code == 200){
               Toast({message:'删除成功',className:'rotation'})
               let dIndex = null;
               this.choiceCustomList.map((val,index) => {
                  if(val.id == id){
                     dIndex = index
                  }
               })
               this.customTagList.splice(index,1);
               this.customTagShowList.splice(index,1);
               this.choiceCustomList.splice(dIndex,1)
               this.$emit("delTag",this.customTagList)
               this.onCancel()
            }else{
               Toast({message:res.message,className:'rotation'});
               this.onCancel()
            }
         })
      },
      // 删除标签
      onDelTag(index,item) {
         this.$refs.delModal.openDialog();
         this.delTagIndex = index;
         this.tagId = item.id;
         // this.$dialog.confirm({
         //    title: '提示',
         //    message: '是否确定删除此自定义标签',
         //    className:'rotation'
         // })
         // .then(() => {
         //    this.saveDelLables(index,item)
         // })
         // .catch(() => {
         //    // on cancel
         // });

      },
      // 确定删除标签
      onSure() {
         this.saveDelLables(this.delTagIndex,this.tagId)
      },
      // 关闭删除标签弹窗
      onCancel() {
         this.$refs.delModal.closeDialog()
      },
      // 保存新增的自定义标签
      onConfirm(name) {
         let dataList = this.defaultTagList.concat(this.customTagList);
         if(this.customTagList.length < 4){
            if(dataList.indexOf(name) == -1){
               let params = {
                  id:'',
                  studentId:this.componentData.studentId,
                  type:7,
                  label:name,
                  checkEnable:false,
                  customEnable:true,
               }
               _saveSingleFavoriteLabel(params).then(res=>{
                  if(res.code == 200){
                     this.customTagList.push({
                        id:res.data,
                        label:name,
                        type: 7,
                        sort:'',
                        studentId:this.componentData.studentId
                     });
                     this.customTagShowList.push(false);
                     this.$emit('addTag',this.customTagList)
                     Toast({message:'新增自定义标签成功',className:'rotation'});
                  }else{
                     Toast({message:res.message,className:'rotation'});
                  }
               })

            }else{
               Toast({message:'请不要重复添加自定义标签哦~',className:'rotation'});
               return;
            }
         }else{
            Toast({message:'最多只能添加4个自定爱好标签哦~',className:'rotation'});
         }
         this.infoShow = false;
      },
      // 关闭弹窗
      onClose() {
         this.infoShow = false;
      },
      // 保存勾选的标签
      onSave() {
         let params = []
         this.defaultTagList.map((val,index)=>{
            let obj = {
               id:val.id,
               studentId:val.studentId,
               type:val.type,
               label:val.label,
               checkEnable:false,
               customEnable:false,
               sort:val.sort
            }
            this.choiceList.map(item => {
               if(val.label == item.label){
                  obj.checkEnable = true
               }
            })
            params.push(obj)
         })
         this.customTagList.map((val,index)=>{
             let obj = {
               id:val.id,
               studentId:val.studentId,
               type:val.type,
               label:val.label,
               checkEnable:false,
               customEnable:true,
               sort:val.sort
            }
            this.choiceCustomList.map(item => {
               if(item.label == val.label){
                  obj.checkEnable = true
               }
            })
            params.push(obj)
         })
         _saveFavoriteLabel(params).then(res=> {
            if(res.code == 200){
               this.$emit('saveTag',this.customTagList,this.choiceCustomList,this.choiceList,this.tagShowList,this.customTagShowList)
               Toast({message:'新增标签成功',className:'rotation'})
            }else{
               Toast({message:res.message,className:'rotation'})
            }
         })
      },
   }
}
</script>

<style lang="scss" scoped>
.child_tag{
   width: 100%;
   height: 100%;
   .child_tag_list{
      width: 100%;
      height:100%;
      padding: 76px 110px;
      position: relative;
      .child_tag_list_default{

         .child_tag_list_default_box{
            margin-bottom:20px;
            &:not(:last-child){
               margin-right:13px;
            }
            &.is_active:nth-child(5n+1){
               border-color:#FF8165;
               box-shadow: 0 1px 4px 0 #FFA591;
            }
            &.is_active:nth-child(5n+2){
               border-color:#FFA97A;
               box-shadow: 0 1px 4px 0 #FFC3A3;
            }
            &.is_active:nth-child(5n+3){
               border-color:#00CF80;
               box-shadow: 0 1px 4px 0 #74FFCA;
            }
            &.is_active:nth-child(5n+4){
               border-color:#5EC0FF;
               box-shadow: 0 1px 4px 0 #88D0FF;
            }
            &.is_active:nth-child(5n+5){
               border-color:#B0A8FF;
               box-shadow: 0 1px 4px 0 #D2CEFF;
            }

         }
      }

      .child_tag_list_custom_box{
         position: relative;
         &:not(:last-child){
            margin-right:13px;
         }
         .icon_del{
            // display: none;
            width:10px;
            height:10px;
            background: url('../../assets/images/children-file/del.png') no-repeat;
            background-size:100% 100%;
            position: absolute;
            top:-5px;
            right:-5px;
            cursor: pointer;
         }
      }
      .child_tag_list_custom{
         .icon_add_tag{
            display: inline-block;
            width:22px;
            height:22px;
            background: url('../../assets/images/children-file/add.png') no-repeat;
            background-size:100% 100%;
            vertical-align: middle;
            cursor: pointer;
         }
      }
      .child_tag_list_default_box{
            display: inline-block;
            padding:4px 12px;
            font-size:12px;
            font-weight:400px;
            font-family:PingFangSC-Regular, PingFang SC;
            border-radius:6px;
            border:1px solid transparent;
             &:nth-child(5n+1){
               color:#F56444;
               background:rgba(255,148,134,0.1);
            }
            &:nth-child(5n+2){
               color:#FF8340;
               background:rgba(255,131,64,0.1);
            }
            &:nth-child(5n+3){
               color:#49CC9A;
               background:rgba(73,204,154,0.1);
            }
            &:nth-child(5n+4){
               color:#25A6F9;
               background:rgba(37,166,249,0.1);
            }
            &:nth-child(5n+5){
               color:#887DF7;
               background:rgba(157,154,299,0.1);
            }
      }
      .child_tag_list_custom_box{
         display: inline-block;
         &.is_active{
            .child_tag_list_custom_box_name{
                  &:nth-child(5n+1){
                     border-color:#FF8165;
                     box-shadow: 0 1px 4px 0 #FFA591;
                  }
                  &:nth-child(5n+2){
                     border-color:#FFA97A;
                     box-shadow: 0 1px 4px 0 #FFC3A3;
                  }
                  &:nth-child(5n+3){
                     border-color:#00CF80;
                     box-shadow: 0 1px 4px 0 #74FFCA;
                  }
                  &:nth-child(5n+4){
                     border-color:#5EC0FF;
                     box-shadow: 0 1px 4px 0 #88D0FF;
                  }
                  &:nth-child(5n+5){
                     border-color:#B0A8FF;
                     box-shadow: 0 1px 4px 0 #D2CEFF;
                  }
            }
            // .icon_del{
            //    display:block;
            // }
         }
         .child_tag_list_custom_box_name{
            display: inline-block;
            padding:4px 12px;
            font-size:12px;
            font-weight:400px;
            font-family:PingFangSC-Regular, PingFang SC;
            border-radius:6px;
            border:1px solid transparent;
            &:nth-child(5n+1){
               color:#F56444;
               background:rgba(255,148,134,0.1);
            }
            &:nth-child(5n+2){
               color:#FF8340;
               background:rgba(255,131,64,0.1);
            }
            &:nth-child(5n+3){
               color:#49CC9A;
               background:rgba(73,204,154,0.1);
            }
            &:nth-child(5n+4){
               color:#25A6F9;
               background:rgba(37,166,249,0.1);
            }
            &:nth-child(5n+5){
               color:#887DF7;
               background:rgba(157,154,299,0.1);
            }
         }
      }
      .child_tag_list_bottom{
         position: absolute;
         right:93px;
         bottom:32px;
         .icon_save{
            display: block;
            width:96px;
            height:47px;
            background: url('../../assets/images/children-file/btn1.png') no-repeat;
            background-size:100% 100%;
            text-align: center;
            line-height:42px;
            color:#74410A;
            font-size:12px;
            font-style: normal;
            font-weight:400;
            font-family: PingFangSC-Regular, PingFang SC;
         }
      }
   }
}
</style>
